// extracted by mini-css-extract-plugin
module.exports = {"root":"DotDivider_root__8KPBv"};